import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter);





function loggedInRedirectDashboard(to, from, next) {
  if (localStorage.token) {
    next('/');
  } else {
    next();
  }
}

function isLoggedIn(to, from, next) {
  if (localStorage.token) {
    next();
  } else {
    next('/login');
  }
}










  const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/auth/login.vue'),
    beforeEnter: loggedInRedirectDashboard,
  },



  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: isLoggedIn,
  },

  {
    path: '/ikk_output',
    name: 'ikk_output',
    component: () => import('../views/ikk_output.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/ikk_outcome',
    name: 'ikk_outcome',
    component: () => import('../views/ikk_out_come.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/ikk_out_come',
    name: 'ikk_out_come',
    component: () => import('../views/ikk_outcome.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/inspektorat_outcome',
    name: 'inspektorat_outcome',
    component: () => import('../views/inspektorat/inspektorat_outcome.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/inspektorat_spip',
    name: 'inspektorat_spip',
    component: () => import('../views/inspektorat/inspektorat_spip.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/inspektorat_apip',
    name: 'inspektorat_apip',
    component: () => import('../views/inspektorat/inspektorat_apip.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bkad_anggaran',
    name: 'bkad_anggaran',
    component: () => import('../views/bkad/bkad_anggaran.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bkad_perda',
    name: 'bkad_perda',
    component: () => import('../views/bkad/bkad_perda.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bkad_pelayanan',
    name: 'bkad_pelayanan',
    component: () => import('../views/bkad/bkad_pelayanan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bkad_informasi',
    name: 'bkad_informasi',
    component: () => import('../views/bkad/bkad_informasi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bkad_silpa',
    name: 'bkad_silpa',
    component: () => import('../views/bkad/bkad_silpa.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bkad_pendapatan',
    name: 'bkad_pendapatan',
    component: () => import('../views/bkad/bkad_pendapatan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bkad_manajemen',
    name: 'bkad_manajemen',
    component: () => import('../views/bkad/bkad_manajemen.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bkad_realisasi',
    name: 'bkad_realisasi',
    component: () => import('../views/bkad/bkad_realisasi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bkad_pegawai',
    name: 'bkad_pegawai',
    component: () => import('../views/bkad/bkad_pegawai.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bkad_pad',
    name: 'bkad_pad',
    component: () => import('../views/bkad/bkad_pad.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bkad_belanja',
    name: 'bkad_belanja',
    component: () => import('../views/bkad/bkad_belanja.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bkad_opini',
    name: 'bkad_opini',
    component: () => import('../views/bkad/bkad_opini.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bkad_sektor',
    name: 'bkad_sektor',
    component: () => import('../views/bkad/bkad_sektor.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dikbud_paud',
    name: 'dikbud_paud',
    component: () => import('../views/dikbud/dikbud_paud.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dikbud_sd',
    name: 'dikbud_sd',
    component: () => import('../views/dikbud/dikbud_sd.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dikbud_smp',
    name: 'dikbud_smp',
    component: () => import('../views/dikbud/dikbud_smp.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dikbud_tamat',
    name: 'dikbud_tamat',
    component: () => import('../views/dikbud/dikbud_tamat.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dikbud_belum',
    name: 'dikbud_belum',
    component: () => import('../views/dikbud/dikbud_belum.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dikbud_cagar',
    name: 'dikbud_cagar',
    component: () => import('../views/dikbud/dikbud_cagar.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dikbud_sekolah',
    name: 'dikbud_sekolah',
    component: () => import('../views/dikbud/dikbud_sekolah.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/satpol_pengaduan',
    name: 'satpol_pengaduan',
    component: () => import('../views/satpol/satpol_pengaduan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/satpol_peraturan',
    name: 'satpol_peraturan',
    component: () => import('../views/satpol/satpol_peraturan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/satpol_pelanggaran',
    name: 'satpol_pelanggaran',
    component: () => import('../views/satpol/satpol_pelanggaran.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/satpol_perda',
    name: 'satpol_perda',
    component: () => import('../views/satpol/satpol_perda.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bpbd_dokumen',
    name: 'bpbd_dokumen',
    component: () => import('../views/bpbd/bpbd_dokumen.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bpbd_informasi',
    name: 'bpbd_informasi',
    component: () => import('../views/bpbd/bpbd_informasi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bpbd_pencegahan',
    name: 'bpbd_pencegahan',
    component: () => import('../views/bpbd/bpbd_pencegahan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bpbd_rawan',
    name: 'bpbd_rawan',
    component: () => import('../views/bpbd/bpbd_rawan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bpbd_penyelamatan',
    name: 'bpbd_penyelamatan',
    component: () => import('../views/bpbd/bpbd_penyelamatan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bpbd_korban',
    name: 'bpbd_korban',
    component: () => import('../views/bpbd/bpbd_korban.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinsos_disabilitas',
    name: 'dinsos_disabilitas',
    component: () => import('../views/dinsos/dinsos_disabilitas.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinsos_korban',
    name: 'dinsos_korban',
    component: () => import('../views/dinsos/dinsos_korban.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinsos_populasi',
    name: 'dinsos_populasi',
    component: () => import('../views/dinsos/dinsos_populasi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinsos_pmks',
    name: 'dinsos_pmks',
    component: () => import('../views/dinsos/dinsos_pmks.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinkes_tampung',
    name: 'dinkes_tampung',
    component: () => import('../views/dinkes/dinkes_tampung.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinkes_rujukan',
    name: 'dinkes_rujukan',
    component: () => import('../views/dinkes/dinkes_rujukan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinkes_pelayanan',
    name: 'dinkes_pelayanan',
    component: () => import('../views/dinkes/dinkes_pelayanan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinkes_bumil',
    name: 'dinkes_bumil',
    component: () => import('../views/dinkes/dinkes_bumil.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinkes_bulin',
    name: 'dinkes_bulin',
    component: () => import('../views/dinkes/dinkes_bulin.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinkes_bayi',
    name: 'dinkes_bayi',
    component: () => import('../views/dinkes/dinkes_bayi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinkes_balita',
    name: 'dinkes_balita',
    component: () => import('../views/dinkes/dinkes_balita.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinkes_anak',
    name: 'dinkes_anak',
    component: () => import('../views/dinkes/dinkes_anak.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinkes_produktif',
    name: 'dinkes_produktif',
    component: () => import('../views/dinkes/dinkes_produktif.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinkes_lansia',
    name: 'dinkes_lansia',
    component: () => import('../views/dinkes/dinkes_lansia.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinkes_hipertensi',
    name: 'dinkes_hipertensi',
    component: () => import('../views/dinkes/dinkes_hipertensi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinkes_diabetes',
    name: 'dinkes_diabetes',
    component: () => import('../views/dinkes/dinkes_diabetes.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinkes_odgj',
    name: 'dinkes_odgj',
    component: () => import('../views/dinkes/dinkes_odgj.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinkes_tbc',
    name: 'dinkes_tbc',
    component: () => import('../views/dinkes/dinkes_tbc.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinkes_hiv',
    name: 'dinkes_hiv',
    component: () => import('../views/dinkes/dinkes_hiv.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinkes_sehat',
    name: 'dinkes_sehat',
    component: () => import('../views/dinkes/dinkes_sehat.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/damkar_layanan',
    name: 'damkar_layanan',
    component: () => import('../views/damkar/damkar_layanan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/damkar_tanggap',
    name: 'damkar_tanggap',
    component: () => import('../views/damkar/damkar_tanggap.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disnaker',
    name: 'disnaker',
    component: () => import('../views/disnaker/disnaker.vue'),
    beforeEnter: isLoggedIn,
  },
  // {
  //   path: '/disnaker_kegiatan',
  //   name: 'disnaker_kegiatan',
  //   component: () => import('../views/disnaker/disnaker_kegiatan.vue'),
  //   beforeEnter: isLoggedIn,
  // },
  // {
  //   path: '/disnaker_perusahaan',
  //   name: 'disnaker_perusahaan',
  //   component: () => import('../views/disnaker/disnaker_perusahaan.vue'),
  //   beforeEnter: isLoggedIn,
  // },
  // {
  //   path: '/disnaker_kompetensi',
  //   name: 'disnaker_kompetensi',
  //   component: () => import('../views/disnaker/disnaker_kompetensi.vue'),
  //   beforeEnter: isLoggedIn,
  // },
  // {
  //   path: '/disnaker_pdrb',
  //   name: 'disnaker_pdrb',
  //   component: () => import('../views/disnaker/disnaker_pdrb.vue'),
  //   beforeEnter: isLoggedIn,
  // },
  // {
  //   path: '/disnaker_kelola',
  //   name: 'disnaker_kelola',
  //   component: () => import('../views/disnaker/disnaker_kelola.vue'),
  //   beforeEnter: isLoggedIn,
  // },
  // {
  //   path: '/disnaker_tenaga',
  //   name: 'disnaker_tenaga',
  //   component: () => import('../views/disnaker/disnaker_tenaga.vue'),
  //   beforeEnter: isLoggedIn,
  // },
  // {
  //   path: '/disnaker_pencari',
  //   name: 'disnaker_pencari',
  //   component: () => import('../views/disnaker/disnaker_pencari.vue'),
  //   beforeEnter: isLoggedIn,
  // },
  // {
  //   path: '/disnaker_kerja',
  //   name: 'disnaker_kerja',
  //   component: () => import('../views/disnaker/disnaker_kerja.vue'),
  //   beforeEnter: isLoggedIn,
  // },
  {
    path: '/dpppa',
    name: 'dpppa',
    component: () => import('../views/dpppa/dpppa.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpppa_kasus',
    name: 'dpppa_kasus',
    component: () => import('../views/dpppa/dpppa_kasus.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpppa_arg',
    name: 'dpppa_arg',
    component: () => import('../views/dpppa/dpppa_arg.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpppa_anak',
    name: 'dpppa_anak',
    component: () => import('../views/dpppa/dpppa_anak.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpppa_perempuan',
    name: 'dpppa_perempuan',
    component: () => import('../views/dpppa/dpppa_perempuan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/ketapang_cadangan',
    name: 'ketapang_cadangan',
    component: () => import('../views/ketapang/ketapang_cadangan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/ketapang_data',
    name: 'ketapang_data',
    component: () => import('../views/ketapang/ketapang_data.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dlh_kualitas',
    name: 'dlh_kualitas',
    component: () => import('../views/dlh/dlh_kualitas.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dlh_kelola',
    name: 'dlh_kelola',
    component: () => import('../views/dlh/dlh_kelola.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dlh_sampah',
    name: 'dlh_sampah',
    component: () => import('../views/dlh/dlh_sampah.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dlh_kegiatan',
    name: 'dlh_kegiatan',
    component: () => import('../views/dlh/dlh_kegiatan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dishub_penyebrangan',
    name: 'dishub_penyebrangan',
    component: () => import('../views/dishub/dishub_penyebrangan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dishub_perhubungan',
    name: 'dishub_perhubungan',
    component: () => import('../views/dishub/dishub_perhubungan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpmd_pengentasan',
    name: 'dpmd_pengentasan',
    component: () => import('../views/dpmd/dpmd_pengentasan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpmd_peningkatan',
    name: 'dpmd_peningkatan',
    component: () => import('../views/dpmd/dpmd_peningkatan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpmd_perkembangan',
    name: 'dpmd_perkembangan',
    component: () => import('../views/dpmd/dpmd_perkembangan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpmd_berkembang',
    name: 'dpmd_berkembang',
    component: () => import('../views/dpmd/dpmd_berkembang.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpmd_mandiri',
    name: 'dpmd_mandiri',
    component: () => import('../views/dpmd/dpmd_mandiri.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpmptsp_investasi',
    name: 'dpmptsp_investasi',
    component: () => import('../views/dpmptsp/dpmptsp_investasi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpmptsp_invest',
    name: 'dpmptsp_invest',
    component: () => import('../views/dpmptsp/dpmptsp_invest.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinkop',
    name: 'dinkop',
    component: () => import('../views/dinkop/dinkop.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinkop_kualitas',
    name: 'dinkop_kualitas',
    component: () => import('../views/dinkop/dinkop_kualitas.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinkop_mikro',
    name: 'dinkop_mikro',
    component: () => import('../views/dinkop/dinkop_mikro.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinkop_usaha',
    name: 'dinkop_usaha',
    component: () => import('../views/dinkop/dinkop_usaha.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dinkop_koperasi',
    name: 'dinkop_koperasi',
    component: () => import('../views/dinkop/dinkop_koperasi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpad_arsip',
    name: 'dpad_arsip',
    component: () => import('../views/dpad/dpad_arsip.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpad_pembangunan',
    name: 'dpad_pembangunan',
    component: () => import('../views/dpad/dpad_pembangunan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpad_membaca',
    name: 'dpad_membaca',
    component: () => import('../views/dpad/dpad_membaca.vue'),
    beforeEnter: isLoggedIn,
  },
  // {
  //   path: '/dispora_wirausaha',
  //   name: 'dispora_wirausaha',
  //   component: () => import('../views/dispora/dispora_wirausaha.vue'),
  //   beforeEnter: isLoggedIn,
  // },
  // {
  //   path: '/dispora_organisasi',
  //   name: 'dispora_organisasi',
  //   component: () => import('../views/dispora/dispora_organisasi.vue'),
  //   beforeEnter: isLoggedIn,
  // },
  // {
  //   path: '/dispora_prestasi',
  //   name: 'dispora_prestasi',
  //   component: () => import('../views/dispora/dispora_prestasi.vue'),
  //   beforeEnter: isLoggedIn,
  // },
  {
    path: '/dispora',
    name: 'dispora',
    component: () => import('../views/dispora/dispora.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dppkb',
    name: 'dppkb',
    component: () => import('../views/dppkb/dppkb.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dppkb_modern',
    name: 'dppkb_modern',
    component: () => import('../views/dppkb/dppkb_modern.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dppkb_peserta',
    name: 'dppkb_peserta',
    component: () => import('../views/dppkb/dppkb_peserta.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dppkb_unmetneed',
    name: 'dppkb_unmetneed',
    component: () => import('../views/dppkb/dppkb_unmetneed.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dppkb_kelahiran',
    name: 'dppkb_kelahiran',
    component: () => import('../views/dppkb/dppkb_kelahiran.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dppkb_kontrasepsi',
    name: 'dppkb_kontrasepsi',
    component: () => import('../views/dppkb/dppkb_kontrasepsi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dppkb_usia',
    name: 'dppkb_usia',
    component: () => import('../views/dppkb/dppkb_usia.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dppkb_kebutuhan',
    name: 'dppkb_kebutuhan',
    component: () => import('../views/dppkb/dppkb_kebutuhan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disdukcapil',
    name: 'disdukcapil',
    component: () => import('../views/disdukcapil/disdukcapil.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disdukcapil_penduduk',
    name: 'disdukcapil_penduduk',
    component: () => import('../views/disdukcapil/disdukcapil_penduduk.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disdukcapil_ktp',
    name: 'disdukcapil_ktp',
    component: () => import('../views/disdukcapil/disdukcapil_ktp.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disdukcapil_kia',
    name: 'disdukcapil_kia',
    component: () => import('../views/disdukcapil/disdukcapil_kia.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disdukcapil_akta',
    name: 'disdukcapil_akta',
    component: () => import('../views/disdukcapil/disdukcapil_akta.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disdukcapil_data',
    name: 'disdukcapil_data',
    component: () => import('../views/disdukcapil/disdukcapil_data.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disdukcapil_potensi',
    name: 'disdukcapil_potensi',
    component: () => import('../views/disdukcapil/disdukcapil_potensi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/diskominfo_internet',
    name: 'diskominfo_internet',
    component: () => import('../views/diskominfo/diskominfo_internet.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/diskominfo_perangkat',
    name: 'diskominfo_perangkat',
    component: () => import('../views/diskominfo/diskominfo_perangkat.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/diskominfo_evaluasi',
    name: 'diskominfo_evaluasi',
    component: () => import('../views/diskominfo/diskominfo_evaluasi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/diskominfo_perencanaan',
    name: 'diskominfo_perencanaan',
    component: () => import('../views/diskominfo/diskominfo_perencanaan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/diskominfo_layanan',
    name: 'diskominfo_layanan',
    component: () => import('../views/diskominfo/diskominfo_layanan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/diskominfo_informasi',
    name: 'diskominfo_informasi',
    component: () => import('../views/diskominfo/diskominfo_informasi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/diskominfo_penyebaran',
    name: 'diskominfo_penyebaran',
    component: () => import('../views/diskominfo/diskominfo_penyebaran.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/diskominfo_keamanan',
    name: 'diskominfo_keamanan',
    component: () => import('../views/diskominfo/diskominfo_keamanan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/diskominfo_data',
    name: 'diskominfo_data',
    component: () => import('../views/diskominfo/diskominfo_data.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dputr_infrastruktur',
    name: 'dputr_infrastruktur',
    component: () => import('../views/dputr/dputr_infrastruktur.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dputr_kawasan',
    name: 'dputr_kawasan',
    component: () => import('../views/dputr/dputr_kawasan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dputr_banjir',
    name: 'dputr_banjir',
    component: () => import('../views/dputr/dputr_banjir.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dputr_pantai',
    name: 'dputr_pantai',
    component: () => import('../views/dputr/dputr_pantai.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dputr_irigasi',
    name: 'dputr_irigasi',
    component: () => import('../views/dputr/dputr_irigasi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dputr_tenaga',
    name: 'dputr_tenaga',
    component: () => import('../views/dputr/dputr_tenaga.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dputr_spam',
    name: 'dputr_spam',
    component: () => import('../views/dputr/dputr_spam.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dputr_limbah',
    name: 'dputr_limbah',
    component: () => import('../views/dputr/dputr_limbah.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dputr_jalan',
    name: 'dputr_jalan',
    component: () => import('../views/dputr/dputr_jalan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dputr_proyek',
    name: 'dputr_proyek',
    component: () => import('../views/dputr/dputr_proyek.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dputr_sertifikat',
    name: 'dputr_sertifikat',
    component: () => import('../views/dputr/dputr_sertifikat.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dputr_bangunan',
    name: 'dputr_bangunan',
    component: () => import('../views/dputr/dputr_bangunan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dputr_minum',
    name: 'dputr_minum',
    component: () => import('../views/dputr/dputr_minum.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bkpsdm_pegawai',
    name: 'bkpsdm_pegawai',
    component: () => import('../views/bkpsdm/bkpsdm_pegawai.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bkpsdm_pendidikan',
    name: 'bkpsdm_pendidikan',
    component: () => import('../views/bkpsdm/bkpsdm_pendidikan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bkpsdm_fungsional',
    name: 'bkpsdm_fungsional',
    component: () => import('../views/bkpsdm/bkpsdm_fungsional.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/bkpsdm_jabatan',
    name: 'bkpsdm_jabatan',
    component: () => import('../views/bkpsdm/bkpsdm_jabatan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpkp',
    name: 'dpkp',
    component: () => import('../views/dpkp/dpkp.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpkp_bencana',
    name: 'dpkp_bencana',
    component: () => import('../views/dpkp/dpkp_bencana.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpkp_rumah',
    name: 'dpkp_rumah',
    component: () => import('../views/dpkp/dpkp_rumah.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpkp_subsidi',
    name: 'dpkp_subsidi',
    component: () => import('../views/dpkp/dpkp_subsidi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpkp_kumuh',
    name: 'dpkp_kumuh',
    component: () => import('../views/dpkp/dpkp_kumuh.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpkp_psu',
    name: 'dpkp_psu',
    component: () => import('../views/dpkp/dpkp_psu.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpkp_rtlh',
    name: 'dpkp_rtlh',
    component: () => import('../views/dpkp/dpkp_rtlh.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpkp_lokasi',
    name: 'dpkp_lokasi',
    component: () => import('../views/dpkp/dpkp_lokasi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpkp_pembangunan',
    name: 'dpkp_pembangunan',
    component: () => import('../views/dpkp/dpkp_pembangunan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpkp_landreform',
    name: 'dpkp_landreform',
    component: () => import('../views/dpkp/dpkp_landreform.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpkp_tanah',
    name: 'dpkp_tanah',
    component: () => import('../views/dpkp/dpkp_tanah.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpkp_kebutuhan',
    name: 'dpkp_kebutuhan',
    component: () => import('../views/dpkp/dpkp_kebutuhan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dpkp_sengketa',
    name: 'dpkp_sengketa',
    component: () => import('../views/dpkp/dpkp_sengketa.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dispar',
    name: 'dispar',
    component: () => import('../views/dispar/dispar.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dispar_persentase',
    name: 'dispar_persentase',
    component: () => import('../views/dispar/dispar_persentase.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dispar_wisatawan',
    name: 'dispar_wisatawan',
    component: () => import('../views/dispar/dispar_wisatawan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dispar_mancanegara',
    name: 'dispar_mancanegara',
    component: () => import('../views/dispar/dispar_mancanegara.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dispar_nusantara',
    name: 'dispar_nusantara',
    component: () => import('../views/dispar/dispar_nusantara.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dispar_hunian',
    name: 'dispar_hunian',
    component: () => import('../views/dispar/dispar_hunian.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dispar_pajak',
    name: 'dispar_pajak',
    component: () => import('../views/dispar/dispar_pajak.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dispar_kontribusi',
    name: 'dispar_kontribusi',
    component: () => import('../views/dispar/dispar_kontribusi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dispar_pdrb',
    name: 'dispar_pdrb',
    component: () => import('../views/dispar/dispar_pdrb.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dispar_pad',
    name: 'dispar_pad',
    component: () => import('../views/dispar/dispar_pad.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dtphp',
    name: 'dtphp',
    component: () => import('../views/dtphp/dtphp.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/diknan',
    name: 'diknan',
    component: () => import('../views/diknan/diknan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disnakkeswan_penyakit',
    name: 'disnakkeswan_penyakit',
    component: () => import('../views/disnakkeswan/disnakkeswan_penyakit.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/ukpbj',
    name: 'ukpbj',
    component: () => import('../views/ukpbj/ukpbj.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/ukpbj_pengadaan',
    name: 'ukpbj_pengadaan',
    component: () => import('../views/ukpbj/ukpbj_pengadaan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/ukpbj_pbj',
    name: 'ukpbj_pbj',
    component: () => import('../views/ukpbj/ukpbj_pbj.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/ukpbj_kontrak',
    name: 'ukpbj_kontrak',
    component: () => import('../views/ukpbj/ukpbj_kontrak.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/ukpbj_tender',
    name: 'ukpbj_tender',
    component: () => import('../views/ukpbj/ukpbj_tender.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/ukpbj_modal',
    name: 'ukpbj_modal',
    component: () => import('../views/ukpbj/ukpbj_modal.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/ukpbj_nilai',
    name: 'ukpbj_nilai',
    component: () => import('../views/ukpbj/ukpbj_nilai.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disperindag_pemantauan',
    name: 'disperindag_pemantauan',
    component: () => import('../views/disperindag/disperindag_pemantauan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disperindag_sasaran',
    name: 'disperindag_sasaran',
    component: () => import('../views/disperindag/disperindag_sasaran.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disperindag_investasi',
    name: 'disperindag_investasi',
    component: () => import('../views/disperindag/disperindag_investasi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disperindag_usaha',
    name: 'disperindag_usaha',
    component: () => import('../views/disperindag/disperindag_usaha.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disperindag_uttp',
    name: 'disperindag_uttp',
    component: () => import('../views/disperindag/disperindag_uttp.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disperindag_pupuk',
    name: 'disperindag_pupuk',
    component: () => import('../views/disperindag/disperindag_pupuk.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disperindag_pembangunan',
    name: 'disperindag_pembangunan',
    component: () => import('../views/disperindag/disperindag_pembangunan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disperindag_izin',
    name: 'disperindag_izin',
    component: () => import('../views/disperindag/disperindag_izin.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disperindag_perluasan',
    name: 'disperindag_perluasan',
    component: () => import('../views/disperindag/disperindag_perluasan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disperindag_industri',
    name: 'disperindag_industri',
    component: () => import('../views/disperindag/disperindag_industri.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disperindag_kawasan',
    name: 'disperindag_kawasan',
    component: () => import('../views/disperindag/disperindag_kawasan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disperindag_informasi',
    name: 'disperindag_informasi',
    component: () => import('../views/disperindag/disperindag_informasi.vue'),
    beforeEnter: isLoggedIn,
  },
  // {
  //   path: '/indikator',
  //   name: 'indikator',
  //   component: () => import('../views/master/indikator.vue'),
  //   beforeEnter: isLoggedIn,
  // },
  // {
  //   path: '/kolom',
  //   name: 'kolom',
  //   component: () => import('../views/master/kolom.vue'),
  //   beforeEnter: isLoggedIn,
  // },
  {
    path: '/tahun',
    name: 'tahun',
    component: () => import('../views/tahun.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/target',
    name: 'target',
    component: () => import('../views/target.vue'),
    beforeEnter: isLoggedIn,
  },


 
  {
    path: '/menuList',
    name: 'menuList',
    component: () => import('../views/dataMaster/menuList.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/klpUsers',
    name: 'klpUsers',
    component: () => import('../views/dataMaster/klpUsers.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/registrasi',
    name: 'registrasi',
    component: () => import('../views/dataMaster/registrasi.vue'),
    beforeEnter: isLoggedIn,
  },


]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

export default router
